import './sortth.css';

interface Props {
  label: string;
  /** Name der Spalte beim Server, siehe `sort` der Liste */
  sortKey: string;
  /** Aktuelle Sortierung, zum Beispiel „name“ oder „-createdAt“ */
  sort: string;
  onSort: (next: string) => void;
  /** In welcher Richtung die Spalte beim ersten Klick sortiert: Texte aufsteigend, Daten und Beträge meist absteigend */
  first?: 'asc' | 'desc';
  className?: string;
}

/**
 * Spaltenüberschrift, die die Liste per Klick sortiert: erster Klick in der Richtung `first`, jeder weitere kehrt sie um. Der Pfeil zeigt die aktive Spalte,
 * Screenreader bekommen `aria-sort`. Die Sortierung läuft auf dem Server (die Listen sind seitenweise), die Seite merkt sie sich in der Adresszeile.
 */
export function SortTh({ label, sortKey, sort, onSort, first = 'asc', className = '' }: Props) {
  const active = sort === sortKey || sort === `-${sortKey}`;
  const desc = sort === `-${sortKey}`;
  const next = active ? (desc ? sortKey : `-${sortKey}`) : first === 'desc' ? `-${sortKey}` : sortKey;
  return (
    <th className={className} aria-sort={active ? (desc ? 'descending' : 'ascending') : undefined}>
      <button type="button" className={`sortth${active ? ' is-active' : ''}`} onClick={() => onSort(next)} title={`Nach „${label}“ sortieren`}>
        <span>{label}</span>
        <svg className="sortth__arrow" viewBox="0 0 12 12" width="10" height="10" aria-hidden="true">
          <path d="M6 2 2.5 6h7z" className={active && !desc ? 'on' : ''} />
          <path d="M6 10 2.5 6h7z" className={active && desc ? 'on' : ''} transform="translate(0 0)" />
        </svg>
      </button>
    </th>
  );
}
